import {
  jb_text_area_css_default
} from "./chunk.C4UDXE35.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.YSL2HSIS.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-text-area/jb-text-area.ts
var JbTextArea = class extends Initiable(FormElement(r)) {
  constructor() {
    super(...arguments);
    this._currentLength = 0;
  }
  _handleInputChange(e) {
    this.value = e.target.value;
  }
  render() {
    return ke`
      <div
        class=${Rt({
      optional: this.requiredText === "" || !this.requiredText,
      error: this.showError || !!this.errorText,
      disabled: !!this.disabled
    })}
      >
        <label for=${this.name}>${this.label}${this.requiredText ? "*" : ""} </label>
        <textarea
          rows="9"
          cols="104"
          placeholder="${this.placeholder}"
          style="resize:vertical"
          ?disabled=${this.disabled}
          .maxLength=${this.maxLength ?? D}
          .name=${this.name}
          .id=${this.name}
          ?required=${!!this.requiredText}
          .value=${typeof this.value === "string" ? this.value : ""}
          @change=${this._handleInputChange}
          @input=${(evt) => {
      if (!this.maxLength) return;
      this._currentLength = evt.currentTarget.value.length;
    }}
          aria-errormessage=${this.showError || !!this.errorText ? `${this.name}_error` : D}
          aria-invalid="${this.showError || !!this.errorText ? "true" : "false"}"
        ></textarea>
        ${this.maxLength ? ke`<div class="counter">
              <span>${this.maxLengthText ?? D}</span><span>${this._currentLength} / ${this.maxLength}</span>
            </div>` : D}
        <div
          aria-live="polite"
          id="${this.name}_error"
        >
          ${this.showError || this.errorText ? ke`<p>
                ${this.showError ? ke`<span>${this.requiredText}</span>` : D}
                ${this.errorText ? ke`<span>${this.errorText}</span>` : D}
              </p>` : D}
        </div>
      </div>
    `;
  }
};
JbTextArea.styles = [reset_css_default, jb_text_area_css_default];
__decorateClass([
  n({ type: Number })
], JbTextArea.prototype, "maxLength", 2);
__decorateClass([
  n()
], JbTextArea.prototype, "maxLengthText", 2);
__decorateClass([
  n()
], JbTextArea.prototype, "placeholder", 2);
__decorateClass([
  r2()
], JbTextArea.prototype, "_currentLength", 2);
JbTextArea = __decorateClass([
  customElement("jb-text-area")
], JbTextArea);

export {
  JbTextArea
};
